import { configureStore } from '@reduxjs/toolkit'
import questionReducer from './features/State Management/questionSlice'
import questionsReducer from './features/State Management/questionsSlice'
import utilitiesReducer from './features/State Management/utilitiesSlice'
import questionnaireMetadataReducer from './features/State Management/questionnaireMetadataSlice'
import localeReducer from './features/State Management/localeSlice'

// load string from localStarage and convert into an Object
// invalid output must be undefined
function loadFromLocalStorage() {
  try {
    const serialisedState = localStorage.getItem('persistentState')
    if (serialisedState === null) return undefined
    return JSON.parse(serialisedState)
  } catch (e) {
    console.warn(e)
    return undefined
  }
}

// convert object to string and store in localStorage
function saveToLocalStorage(state) {
  try {
    const serialisedState = JSON.stringify(state)
    localStorage.setItem('persistentState', serialisedState)
  } catch (e) {
    console.warn(e)
  }
}

const store = configureStore({
  reducer: {
    question: questionReducer,
    questions: questionsReducer,
    utilities: utilitiesReducer,
    questionnaireMetadata: questionnaireMetadataReducer,
    locale: localeReducer,
  },
  preloadedState: loadFromLocalStorage(),
})

store.subscribe(() => saveToLocalStorage(store.getState()))

export default store
